import { render, staticRenderFns } from "./PermisionInformation.vue?vue&type=template&id=e51352f2&scoped=true"
import script from "./PermisionInformation.vue?vue&type=script&lang=js"
export * from "./PermisionInformation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PermisionInformation.vue?vue&type=style&index=1&id=e51352f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51352f2",
  null
  
)

export default component.exports